module.exports = __webpack_public_path__ + "img/edit-icon.f22e5e55.svg";